<header>
  <kin-circular-icon-btn
    [routerLink]="['/contents/' + this.type()]"
    [queryParams]="backQueryParams()"
    icon="arrow_before"
    backgroundColor="transparent"
  />
  @if (contentRessource.isLoading()) {
    <kin-skeleton unit="px" [height]="42" [width]="300" />
  } @else if (content(); as content) {
    <h1>{{ content.name | translate | upperFirstLetter }}</h1>
  } @else {
    <h1>{{ 'content_details.unavailable' | translate }}</h1>
  }

  <button class="cta-primary" [routerLink]="['edit']">
    <kin-icon name="edit" />
    <span>{{ 'content.edit' | translate | uppercase }}</span>
  </button>
</header>
<main>
  <app-content-availability-block
    class="field"
    [loading]="contentRessource.isLoading()"
    [moderationReasons]="moderationRefusedReasons()"
    [moderationRefusedReasons]="contentModerationRefusedReasons()"
  />
  <app-content-global-stats-block class="field" [content]="contentStatistics()" />
  <app-content-views-distribution-block
    class="field"
    [loading]="viewerRepartitionRessource.isLoading()"
    [viewerRepartition]="viewerRepartition()"
  />
  <div class="field content-preview">
    <h4>{{ 'content_details.content' | translate }}</h4>
    <app-content-preview [contentType]="type()" [content]="content()" />
  </div>
</main>
